import ListItem from '@tiptap/extension-list-item'

export default ListItem.extend({
  addAttributes () {
    return {
      ...this.parent?.(),
      type: { default: 'list-item', rendered: false }
    }
  }
})